module.exports = __webpack_public_path__ + "img/finger/finger@2x.png";


//////////////////
// WEBPACK FOOTER
// ./img/finger/finger@2x.png
// module id = 65
// module chunks = 3